type YearIntervals = Record<string, { from?: number; to: number }>;

type GeneratedIntervals = {
  finishedAtIntervals: YearIntervals;
  lastIntervalYear: number;
};

const currentYear = new Date().getFullYear();

export const { finishedAtIntervals, lastIntervalYear } =
  ((): GeneratedIntervals => {
    const finishedAtIntervals: YearIntervals = {
      '1999_and_older': {
        to: 1999,
      },
    };

    let pointerYear = 2000;

    let lastIntervalYear = pointerYear;

    while (pointerYear < currentYear) {
      let toYear = pointerYear + 7;
      const interval = { from: pointerYear, to: toYear };

      finishedAtIntervals[`${pointerYear}_to_${toYear}`] = interval;
      // find the last interval added
      if (toYear + 8 > currentYear) {
        toYear += 8;
        pointerYear += 8;
        lastIntervalYear = toYear;
        finishedAtIntervals[`${pointerYear}_and_newer`] = {
          from: pointerYear,
          to: toYear,
        };
        break;
      }
      pointerYear += 8;
    }

    return {
      finishedAtIntervals,
      lastIntervalYear,
    };
  })();

export const getFinishedAtIntervalMessage = (interval: {
  from?: number;
  to: number;
}) => {
  const { from, to } = interval;

  if (!from) {
    return {
      id: 'finished_at_interval.year_and_older',
      values: { year: to },
    };
  }
  if (to >= currentYear && currentYear >= from) {
    return {
      id: 'finished_at_interval.year_and_newer',
      values: { year: from },
    };
  }

  return {
    text: `${from} - ${to}`,
  };
};
